import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { defaultPosition, IScreenPosition, OrderContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"

/* Protopia Ecosystem component */
export interface IHTMLPrimitiveProps {
   
}
const OrderPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: OrderContent = (props.primitive || {}) as OrderContent 
    const { style, className } = primitive 
    const position: IScreenPosition = { ...defaultPosition(), ...primitive.position }

    useEffect(() => {
        addCSSClass(
            `landing-order-${primitive.id}`,
            ` .landing-order-${primitive.id} {
                position: absolute;
                width:${ getCssDemention(position.width, "200px") };
                height:${ getCssDemention(position.height, "200px") };
                top:${getCssDemention(position.top, "0")};
                left:${getCssDemention(position.left, "0")};
                transform: rotate(${ position.rotate || 0 }deg);
            }`
        )
        return () => removeCSSClass(`landing-order-${primitive.id}`)
    },[])
    
    const num = (primitive.order || 0) + 1
    return <div 
        className={`landing-card-field landing-card-field-order landing-card-field-order-${primitive.id} ${className}`}  
        style={{ ...style }}  
        data-primitive-type={primitive["data-primitive-type"]}
    >  
        { primitive.significant_zero ? num.toString().padStart(2, "0") : num }
        {
            primitive.is_show_full 
                ? 
                <>
                    <span className="opacity_5 px-1">
                        /
                    </span>
                    <span className="opacity_5 ">
                        { 
                            primitive.significant_zero 
                                ? 
                                primitive.length.toString().padStart(2, "0")
                                :
                                primitive.length
                        }
                    </span>
                </>
                : 
                ""
        }
    </div>
}
export default OrderPrimitive